module.exports = __webpack_public_path__ + "static/img/footer1.452f519f.png";